import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'

export const PageContainer = styled.div`
  margin: 10px 15px 10px 20px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    margin: 15px 48px 25px;
  }
`

export const PageHeader = styled.h1`
  ${DefaultFontStyle};
  color: ${props => props.theme.colours.black};
  margin: 0px 10px 10px 0px;
  font-weight: 600;
  font-size: 24px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 38px;
  }
`

export const ProfileForm = styled.div`
  background-color: ${props => props.theme.colours.white};
  border-radius: 10px;
  width: 100%;
  max-width: 830px;
  padding: 30px;
  box-shadow: ${props => props.theme.boxShadow};

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    padding: 42px;
  }
`

export const SubHeader = styled.h2`
  ${DefaultFontStyle};
  color: ${props => props.theme.colours.black};
  margin: 0px 10px 10px 0px;
  font-weight: 600;
  font-size: 20px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 32px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 35px;
  justify-content: center;

  @media only screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    justify-content: flex-end;
    margin-top: 200px;
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
`

export const FieldLabel = styled.label`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  margin: 30px 0 10px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 18px;
  }
`

export const HelperText = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 14px;
  color: ${props => props.theme.colours.darkRed};
  margin: 0;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 16px;
  }
`

export const TextField = styled.input`
  border: none;
  border-bottom: 1px solid #b8b8b8;
  padding: 10px 0px;
  font-size: 14px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 16px;
  }

  &:hover,
  &:focus,
  &:active {
    outline: none;
    cursor: default;
  }
`
